import StorePC from './storePC';/* オープンクローズを流用するため読み込み */
import BgColorChange from './bgcolorChange';
const storePC = new StorePC();

const bgColorChange = new BgColorChange();

export default class MeganaviStoreSP {
    constructor($navi,$overlay,$fixed,$storeBtn,$onlineBtn,$fontBtn){

        this.$navi = $navi;

        this.$overlay = $overlay;
        this.$fixed = $fixed;

        this.$storeBtn = $storeBtn;
        this.$onlineBtn = $onlineBtn;
        this.$fontBtn = $fontBtn;

        this.$onlineList = $("#l-header__btn-online__list");
        this.$storeList = $("#l-header__btn-store__list");

        this.$trigger = $("#l-header__trigger");
        this.$Acc = $(".l-header__meganavi-acc");

        this.open = false;
        this.Position = 0;
        this.PosiSaveFlg = false; /* スクロール値を保存したかを監視※メガナビ、ストア、オンライン共通 */

        this.motionFlg = false; /* 動作中か監視 */

    }
    init(){

        let _this = this;

        _this.$trigger.on("click",function(){

            if(_this.motionFlg) return;
            _this.motionFlg = true;

            let $target = _this.$navi;

            // console.log("mega",_this.Position);

            if(_this.$storeList.hasClass("open")){
                storePC.store(_this.$storeList,_this.$storeList,'hide');
                _this.$storeList.removeClass('open');
            }
            if(_this.$onlineList.hasClass("open")){
                storePC.store(_this.$onlineList,_this.$onlineList,'hide');
                _this.$onlineList.removeClass('open');
            }

            if(_this.$navi.hasClass("open")){
                _this.meganavi($target,'hide');
            }else{
                _this.meganavi($target,'show');
                // scr = $(window).scrollTop();
            }
        });

        /* 店舗とオンラインストアで使用 */
        let dropDown = function($target,$closeTarget){
            if($target.hasClass("open")){
                $target.removeClass('open');
                _this.statusUpddate();
                // if($("#p-top")[0]) bgColorChange.update(_this.Position,$('#l-kv').height(),$('#l-header').height());
                // if($("#p-top")[0]) $('#l-header').addClass('transparent');
                storePC.store($target,$closeTarget,'hide');
                // console.log($target,"close",_this.Position);
                _this.closeReset();
            }else{
                if(!_this.open){
                    _this.open = true;
                    _this.Position = $(window).scrollTop();
                }
                // console.log($target,"open",_this.Position);
                // _this.meganaviResize('show');
                if($("#p-top")[0]) $('#l-header').removeClass('transparent');
                $target.addClass('open');
                $closeTarget.removeClass('open');
                _this.statusUpddate();
                // bgColorChange.update(_this.Position,$('#l-kv').height(),$('#l-header').height());
                storePC.store($target,$closeTarget,'show');
                setTimeout(function(){
                    _this.openSet();
                    $('html,body').animate({scrollTop: 0}, 1);
                    _this.motionFlg = false;
                },6e2);
            }
        }

        _this.$storeBtn.on("click",function(){
            if(_this.motionFlg) return;
            _this.motionFlg = true;
            dropDown(_this.$storeList,_this.$onlineList);
        });
        _this.$onlineBtn.on("click",function(){
            if(_this.motionFlg) return;
            _this.motionFlg = true;
            dropDown(_this.$onlineList,_this.$storeList);
        });
        _this.$Acc.on("click",function(){
            if($(window).width() < 750){
                let $target = $(this).next();
                if($(this).hasClass("open")){
                    $(this).removeClass('open');
                    _this.acc($target,'hide');
                }else{
                    $(this).addClass('open');
                    _this.acc($target,'show');
                }
                return false;
            }
        });



        // $(window).on("scroll",function(e){
        //     if($("body").hasClass("is-open-navi")) e.preventDefault();
        // });

        window.addEventListener('resize', () => {
            _this.resize();
        }, false);


        $(window).on("onorientationchange",function (e) {

        });


    }
    meganavi($target,type){

        let _this = this;

        console.log("meganavi",type);

        switch (type) {
            case 'hide': // --------------- hide --------------- //
                // openFlg = false;
                // motion
                _this.$trigger.removeClass("open");
                _this.$navi.removeClass("open");
                _this.statusUpddate();
                TweenLite.set($('.l-store__navi'), {opacity: 1});
                _this.meganaviResize('hide');

                TweenMax.to(_this.$navi, 0.68, {
                    opacity: 0,
                    display:'none',
                    x:'0px',
                    delay:0.2,
                    ease: Power2.easeOut,
                    onStart:function(){
                        _this.closeReset();
                    },
                    onComplete:function(){
                        _this.motionFlg = false;
                    }
                });
                TweenMax.to(_this.$overlay, 0.68, {
                        display: 'none',
                        opacity:0,
                        delay:0.2,
                        ease: Power2.easeOut
                    }
                );
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // openFlg = true;
                // motion
                _this.$trigger.addClass("open");
                _this.$navi.addClass("open");
                if(!_this.open){
                    _this.Position = $(window).scrollTop();
                }
                _this.statusUpddate();
                TweenLite.set($('.l-store__navi'), {opacity: 0});
                TweenMax.to(_this.$navi, 0.68, {
                    opacity: 1,
                    display:'block',
                    x:'0px',
                    ease: Power2.easeOut,
                    onComplete:function(){
                        _this.$fixed.css({'position':'relative'});
                        _this.openSet();
                        _this.meganaviResize('show');
                    }
                });
                TweenMax.to(_this.$overlay, 0.12, {
                        display: 'block',
                        opacity:1,
                        ease: Circ.easeOut,
                        onComplete:function(){
                            $('html,body').animate({scrollTop: 0}, 1);
                            _this.motionFlg = false;
                        }
                    }
                );
                break; // --------------- show (end) --------------- //
        }
    }

    acc ($target,type){

        let _this = this;

        switch (type) {
            case 'hide': // --------------- hide --------------- //
                // motion
                TweenMax.to($target, 0.12, {
                        display: 'none',
                        opacity:0,
                        ease: Circ.easeOut,
                        onComplete:function(){
                            _this.meganaviResize('show');
                        }
                    }
                );
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // motion
                TweenMax.to($target, 0.12, {
                        y: '0',
                        display: 'block',
                        opacity:1,
                        ease: Circ.easeOut,
                        onComplete:function(){
                            // _this.meganaviResize('show');
                        }
                    }
                );
                break; // --------------- show (end) --------------- //
        }
    }

    statusUpddate(){
        let _this = this;
        if(_this.$storeList.hasClass('open') || _this.$onlineList.hasClass('open') || _this.$navi.hasClass('open')){
            _this.open = true;
        }else{
            _this.open = false;
            bgColorChange.update(_this.scr,$('#l-kv').height(),$('#l-header').height());
        }

    }

    resize(){

        let _w = $(window).innerWidth();

        // if(this.open){
        //     let _h = window.innerHeight - $("#l-header").innerHeight();
        //     $("#l-header__navi").css({height:_h});
        // }

        if(_w>750||!this.open&&_w<=750){
            this.shutdown();
        }


    }

    openSet(){
      /* オープン状態を監視 */

      this.resize();

      setTimeout(function(){
          $("body").addClass("is-open-navi");
      },1e2);

    }

    shutdown(){
        /* 強制的に閉じるとき使う */
        if($("body").hasClass("is-open-navi")){
            this.$fixed.removeAttr('style');
            this.$navi.removeAttr("style");
            $("body").removeClass("is-open-navi");
            $("#l-header__trigger").removeClass("open");
        }
    }

    closeReset(){
        /* 閉じた後に元に戻す */
        if(this.open) return;

        let _this = this;


        _this.$fixed.removeAttr('style');
        _this.$navi.removeAttr("style");
        _this.meganaviResize('hide');
        $('html,body').css({"pointer-events":"none"});
        $("body").removeClass("is-open-navi");
        $('html,body').animate({scrollTop: _this.Position},1);
        setTimeout(function(){
            $('html,body').css({"pointer-events":""});
            $("body").removeClass("is-open-navi");
            $('body').removeAttr('style');
            _this.motionFlg = false;
        },2e2);


    }

    meganaviResize (type) {
        let _this = this;
        switch (type) {
            case 'hide': // --------------- hide --------------- //
                $('body').removeAttr('style');
                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // let _height;
                // if($('#l-header__btn-online__list').height() > $('#l-header__navi').height()){
                //     _height = $('#l-header__fixed').height() + $('#l-header__btn-online__list').height() + 30;
                // }else{
                //     _height = $('#l-header__fixed').height() + $('#l-header__navi').height();
                // }
                // TweenLite.set($('body'), {overflow: 'hidden',height: _height});
                // TweenLite.set($('body'), {overflow: 'visible',height: _height});
                break; // --------------- show (end) --------------- //
        }
    }

}